function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeginner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7CCC92"
    },
    d: "M472.091,15.483c-0.89-7.569-6.9-13.69-14.579-14.581c-3.784-0.445-93.271-11.353-161.165,56.541 c-19.034,19.033-31.832,39.735-40.625,59.77C229.121,48.652,162.562,0.013,84.539,0.013H51.149c-9.238,0-16.695,7.457-16.695,16.695 v33.391c0,101.285,82.363,183.092,183.648,183.092c18.365,0,30.164,0.111,37.62,0.111c12.133,0.223,13.021,0.334,13.021,0.445 c29.162,0,93.718-6.567,145.584-58.434C482.22,107.419,472.538,19.267,472.091,15.483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34B772"
    },
    d: "M414.327,175.313c-51.866,51.867-116.422,58.434-145.584,58.434c0-0.111-0.888-0.223-13.021-0.445 V117.213c8.793-20.034,21.591-40.737,40.625-59.77C364.241-10.451,453.728,0.456,457.512,0.901 c7.681,0.89,13.69,7.012,14.579,14.581C472.538,19.267,482.22,107.419,414.327,175.313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDDD47"
    },
    d: "M367.691,128.121l-95.276,95.274v71.79c0,9.238-7.456,16.694-16.695,16.694 s-16.695-7.457-16.695-16.694v-71.79l-95.276-95.274c-6.567-6.567-6.567-17.141,0-23.707c6.568-6.456,17.029-6.456,23.597,0 l88.373,88.374l88.373-88.374c6.568-6.456,17.029-6.456,23.597,0C374.258,110.98,374.258,121.554,367.691,128.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7D100"
    },
    d: "M367.691,128.121l-95.276,95.274v71.79c0,9.238-7.456,16.694-16.695,16.694V192.786l88.373-88.374 c6.568-6.456,17.029-6.456,23.597,0C374.258,110.98,374.258,121.554,367.691,128.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91867E"
    },
    d: "M389.173,345.048c-8.348,0-20.258-0.111-28.271,0.111c-19.255-40.514-59.991-66.892-105.18-66.892 h-0.111c-45.077,0-85.925,26.379-105.068,66.781h-28.494c-75.129,0-116.756,66.336-116.756,112.192 c0,31.945,19.033,54.761,49.975,54.761h400.687c31.722,0,50.755-22.817,50.755-54.315 C506.708,411.607,464.858,345.048,389.173,345.048z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#847976"
    },
    d: "M506.708,457.686c0,31.498-19.033,54.315-50.755,54.315H255.721V278.267 c45.19,0,85.925,26.379,105.18,66.892c8.014-0.223,19.923-0.111,28.271-0.111C464.858,345.048,506.708,411.607,506.708,457.686z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeginner);
export default __webpack_public_path__ + "static/media/beginner.ffb8a4f417a012a6333207f92735fb45.svg";
export { ForwardRef as ReactComponent };